import * as demoBrand from "./demoBrand";

export function getProducts() {
    let products = demoBrand.getProducts();
    products.pauseInvoiceEnabled = true;

    return products;
}
